// extracted by mini-css-extract-plugin
module.exports = {"status":"status_status__N4AjF","rejected":"status_rejected__1HPhn","completed":"status_completed__1v4-8","pending":"status_pending__89BFz"};